<template>
    <p>Ты принес токен, Джони?</p>
</template>

<script>
export default {
    name: 'Login',
};
</script>